export default {
  pleaseEnterKeywords: '请输入关键词',
  search: '搜索',
  code: '代码',
  name: '名称',
  describe: '描述',
  description: '描述',
  remarks: '备注',
  import: '导入',
  more: '更多',
  edit: '编辑',
  delete: '删除',
  export: '导出',
  pleaseSelect: '请选择',
  cancel: '取消',
  save: '保存',
  create: '新增',
  reset: '重置',
  operate: '操作',
  seqNo: '序号',
  close: '关闭',
  confirm: '确定',
  view: '查看',
  tip: '提示',
  valueType: '数据类型',
  importFromExcel: '从Excel导入',
  importFromOwl: '从Owl导入',
  downloadTemplete: '下载模板',
  uploadFile: '上传文件',
  complete: '完成',
  clickDownloadTemplete: '点击图标下载模板,填写信息如已下载完成,点击',
  nextStep: '下一步',
  onlyOne: '一次只能上传一个文件，或',
  clickUpload: '点击上传',
  downloadUploadResult: '文件上传完成(点击图标下载导入结果)',
  uploadSuccess: '上传成功',
  previous: '上一步',
  viewDownloadResult: '请下载文档查看上传结果',
  loginExpired: '登录已过期,请重新登录',
  loginAgain: '重新登录',
  pleaseSelectDate: '选择日期',
  theDecimalPointMustGreaterThan0: '精度必须大于0',
  theLengthMustGreaterThan0: '长度必须大于0',
  valueTypeStringMusthEnterTheLength: '数据类型为字符串,请输入长度',
  valueTypeDecimalMusthEnterTheLength: '数据类型为小数,请输入长度',
  theDecimalPointCannotExceed30: '精度不能超过30',
  theLengthCannotExceed65: '长度不能超过65',
  serialNumber: '序号',
  hint: '提示',
  Sure: '确定',
  Cancel: '取消',
  ContinueExportingAllData:
    '当前没有选中任何记录,系统将默认导出系统中所有数据,该操作时间会比较长,请确认是否要继续',
  sequenceNumberMustThanZero: '序号必须为大于0的正整数',
  LengthCannotExceedTenCharacters: '长度不能超过10个字符',
  SerialNumberCannotBeEmpty: '序号不能为空',
  to: '至',
  state: '状态',
  type: '类型',
  Result: '结果',
  Refresh: '刷新',
  Retry: '重试',
  Restore: '还原',
  batchDeletion: '批量删除',
  selectRule: '选择规则',
  pleaseChoose: '请选择',
  PleaseSearchForTheName: '请搜索名称',
  new: '新增',
  listPresentation: '列表展示',
  cardDisplay: '卡片展示',
  yes: '是',
  no: '否',
  pleaseEnter: '请输入',
  enterLabelName: '请输入标签名称',
  enterLabelCode: '请输入标签代码',
  confirmDeleteLabel: '是否确定要删除该标签？',
  enterNameOrCode: '请输入名称或代码',
  enterTheDictionaryValue: '请输入字典值',
  saveSuccessFul: '保存成功',
  addDictionaryEntries: '新增字典项',
  editDictionaryEntries: '编辑字典项',
  confirmDeleteReidentityGroup: '是否确定要删除改标识组',
  addTo: '添加',
  encode: '编码',
  selectExtendedProperties: '选择扩展属性',
  entityCode: '实体代码',
  entityCorrespondence: '实体对应关系',
  impactAnalysis: '影响分析',
  dataOwner: '数据所有者',
  entityType: '实体类型',
  uniquenessRequirements: '唯一性要求',
  inheritedAttributes: '继承属性',
  inheritEntities: '继承实体',
  attributeCodeOrName: '属性编码或名称',
  downloadFile: '下载文件',
  deleteFile: '删除文件',
  titleCannotBeEmpty: '标题不能为空',
  processTypeCannotBeEmpty: '流程类型不能为空',
  approverCannotBeEmpty: '审批人不能为空',
  deadlineCannotBeEmpty: '截止时间不能为空',
  confirmToDelete: '是否确定要删除?',
  confirmToDeleteForever: '此操作将永久删除,是否要继续?',
  confirmToContinueAwaite: '可能需要等待时间较长，请确认是否要继续？',
  ruleExpressionsTips: '规则表达式生成的属性值还未编辑完成，请修改后再进行保存',
  assetCatalogTree: '资产目录树',
  noDataYet: '暂无数据',
  directoryTreeConfiguration: '目录树配置',
  addHierarchies: '添加层级',
  directory: '目录',
  expandByEntity: '按实体展开',
  recursiveOrNot: '是否递归',
  characteristicAttributes: '*属性',
  associateTheParentEntity: '关联上级实体',
  pleaseSelectDataType: '请选择数据类型',
  onlyOneCanBeExpandedByEntity: '只能有一个按实体展开',
  selectTheCriteriaFirst: '请先选择标准',
  selectHierarchyWantToDelete: '请选择要删除的层级',
  deleteDataConfirm: '是否要删除该数据?',
  keepAtLeastOneConfigurationDetail: '至少保留一个配置详情',
  collection: '收藏',
  collectionSuccess: '收藏成功',
  cancelCollectionSuccess: '取消收藏成功',
  searchTips: '说明：搜索支持多个词组合搜索，组合搜索请在词与词之间*连接（设备*阀门）',
  searchRange: '搜索范围',
  Data: '数据',
  DocumentFullText: '文档全文',
  searchResultTips: '暂无数据：请更换标准或搜索关键字',
  BrowsingPosition: '浏览位号',
  DownloadFiles: '下载文件',
  BrowsingDocuments: '浏览文档',
  UpgradeVersion: '升版',
  ViewHistory: '查看历史',
  DocumentAssociation: '文档关联',
  DocumentName: '文档名称',
  filesPath: '文件路径',
  fileType: '文件类型',
  uploadTime: '上传时间',
  uploadUser: '上传用户',
  NoDataNow: '暂无数据',
  documentCode: '文档编码',
  documentVersion: '文档版本',
  updataTime: '更新时间',
  Categories: '类别',
  file: '文件',
  zipFile: 'zip文件',
  synchronouslyCreatingDocuments: '同步创建文档',
  bitNumberTree: '位号树',
  documentTree: '文档树',
  downloadProgress: '下载进度',
  successfulDeAssociation: '解除关联成功',
  selectUnassociate: '请选择要解除关联的数据',
  acquisitionTime: '采集时间',
  addAttributes: '新增属性',
  addRules: '新增规则',
  templateProperties: '模板属性',
  baseProperties: '基础属性',
  noDateYet: '暂无日期',
  deactivated: '已停用',
  oning: '开启中',
  taskTypeName: '任务类型名称',
  priority: '优先级',
  startTime: '开始时间',
  endTime: '结束时间',
  creationTime: '创建时间',
  lastModifiedTime: '最后修改时间',
  firingInterval: '触发间隙',
  selectStartTime: '请选择开始时间',
  selectEndTime: '请选择结束时间',
  enterTaskTypeName: '请输入任务类型名称',
  enterTaskTypeCode: '请输入任务类型编码',
  enterTaskTypeDes: '请输入任务类型描述',
  enterTaskTypePriority: '请输入任务类型优先级',
  enterTimeInterval: '请输入时间间隔',
  typeName: '类型名称',
  entityName: '实体名称',
  startDate: '开始日期',
  endDate: '结束日期',
  mainDatadescription: '主数据类型描述',
  bindingEntities: '绑定实体',
  fileLists: '文件清单',
  documentLists: '文档清单',
  documentListings: '文档清单',
  whetherMainData: '请选择是否主数据',
  selectWhetherType: '请选择是否是类型',
  folder: '文件夹',
  pleaseSelectFolder: '请选择文件夹',
  documentUpscaling: '文档升版',
  pleaseEnterFileName: '请输入文件名称',
  associationSuccessful: '关联成功',
  setAsMasterFile: '设为主文件',
  delConfirm: '是否确定要删除？',
  attributeValue: '属性值',
  codeOrName: '编码或名称',
  expandAll: '展开全部',
  collapseThemAll: '收起全部',
  unfavorite: '取消收藏',
  favorites: '收藏夹',
  PleaseSelectLeibieName: '请选择类型名称',
  dictionaryValues: '字典值',
  objectEncodingCannotNull: '对象编码不能为空',
  documentNameCannotEmpty: '文档名称不能为空',
  filterEntityCollection: '筛选实体归集',
  filterDataLabels: '筛选数据标签',
  gotoEntityManagement: '跳转至实体管理',
  goToDatasetManagement: '跳转至数据集管理',
  displayStandardName: '显示标准名称',
  expand: '展开',
  collapse: '收起',
  nodeName: '节点名称',
  pbsStructure: 'PBS结构',
  enterEntityOrEntityCode: '请输入实体名称或实体代码',
  tags: '位号',
  addNewProject: '新增工程',
  engineeringCoding: '工程编码',
  engineeringName: '工程名称',
  dataRightsCode: '数据权限分类码',
  subProjectCoding: '子工程编码',
  theNameOfTheSubproject: '子工程名称',
  engineeringUnitCoding: '工程单元编码',
  engineeringUnitName: '工程单元名称',
  addedAssociatedEntityDataObject: '新增关联实体数据对象',
  pleaseEnterTheProjectCode: '请输入工程编码',
  pleaseEnterAProjectName: '请输入工程名称',
  pleaseEnterTheDataRightsCode: '请输入数据权限分类码',
  pleaseEnterTheSubprojectCode: '请输入子工程编码',
  pleaseEnterTheSubprojectName: '请输入子工程名称',
  pleaseEnterTheEngineeringUnitCode: '请输入工程单元编码',
  pleaseEnterNameOfTheTngineeringUnit: '请输入工程单元名称',
  addASubproject: '新增子工程',
  editTheProject: '编辑工程',
  addEngineeringUnit: '新增工程单元',
  editEngineeringUnit: '编辑子工程',
  editTheEngineeringUnit: '编辑工程单元',
  saveFailed: '保存失败',
  confirmTheDeletionTheNode: '确认删除该节点？',
  confirmTheDeletionOfTheSelectedData: '确认删除所选数据？',
  downloadUploadErrorResult: '上传失败，点击图标下载上传结果查看',
}
